module.exports = __webpack_public_path__ + "img/Wigo_icons_redesign_customer_support.648ccee0.svg";